import { Component, OnInit, OnDestroy } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import moment from "moment";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";
import { Subject, zip } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getBalance, getDebtInvoices } from "@edp-store/selectors/dashboard.selectors";
import { Moment } from "moment";
import { IInvoice, IInvoicesChart } from "@edp-models/invoices.model";

@Component({
    selector: "edp-widget-payment-debt",
    templateUrl: "./edp-widget-payment-debt.component.html"
})
export class EdpWidgetPaymentDebtComponent implements OnInit, OnDestroy {
    public contractSelected: Contract;
    public date: Moment;
    public balanceObject: {
        dateFrom: string;
        dateTo: string;
        balance: number;
        debtBalance: number;
        invoices?: IInvoice[];
        movements?: any[];
        invoicesChart?: IInvoicesChart[];
    };
    public totalDebtInvoices: number;
    private unsubscribe = new Subject();

    constructor(
        private store: Store<IAppState>
    ) { }

    public ngOnInit() {
        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getContract)
        ).subscribe((contract: Contract) => {
            this.contractSelected = contract;
        });

        zip(
            this.store.pipe(
                takeUntil(this.unsubscribe),
                select(getBalance)
            ),
            this.store.pipe(
                takeUntil(this.unsubscribe),
                select(getDebtInvoices)
            ),
        ).subscribe(([balance, invoices]) => {
            const debtInvoices: IInvoice[] = [];
            this.date = moment().add(2, "day");

            (invoices ?? []).forEach((invoice: IInvoice) => {
                if (moment(invoice.faedn) < moment()) {
                    debtInvoices.push(invoice);
                } else {
                    this.date = moment(invoice.faedn);
                }
            });

            this.balanceObject = balance;

            this.totalDebtInvoices = 0;
            if (balance.invoices && balance.invoices.length) {
                this.totalDebtInvoices = debtInvoices && debtInvoices.length ? debtInvoices.length : 0;
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
